import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
import { useTranslation } from 'react-i18next'
import AceScholarshipsLogo  from '@assets/AceScholarshipLogo1.jpg'

export type CheckEmailProps = {
  onResend: () => void
} & ChildrenProp

export const CheckEmail = ({ children, onResend }: CheckEmailProps) => {
  const { t: translate } = useTranslation()

  return (
    <div className="flex flex-col">
      <img
        alt={translate('ace_logo')}
        src={AceScholarshipsLogo}
        className="mx-auto h-auto"
        width="100%"
      />
      <h1 className="text-lg font-semibold text-gray-900 text-center mt-10 mb-4">
        {translate('check_your_email')}
      </h1>
      {children}
      <div className="flex items-center justify-center gap-1 text-xs font-medium">
        <span className="text-gray-500">
          {translate('didnt_receive_an_email')}
        </span>
        <span className="text-primary hover:cursor-pointer" onClick={onResend}>
          {translate('resend')}
        </span>
      </div>
    </div>
  )
}

export type InstructionsProps = {
  className?: string
} & ChildrenProp
const Instructions = ({ children, className }: InstructionsProps) => {
  return (
    <div
      className={cn(
        'text-sm text-gray-500 font-medium text-center mb-7',
        className
      )}
    >
      {children}
    </div>
  )
}

CheckEmail.Instructions = Instructions

const ButtonSlot = ({ children }: ChildrenProp) => {
  return <div className="flex justify-center mb-5">{children}</div>
}

CheckEmail.ButtonSlot = ButtonSlot
